module.exports = __webpack_public_path__ + "img/frame_1_background.5758cd26.png";